document.addEventListener('DOMContentLoaded', () => {
	const inputs = document.querySelectorAll('.account__block-item .form .input input');
	const buttonSubmit = document.querySelector('#customer_login .form__submit');
	
	const inputName = document.getElementById('customer[email]');
	const inputPassword = document.getElementById('customer[password]');
	
	buttonSubmit.setAttribute('disabled', true);
	
	const handleInputChange = () => {
		if (inputName.value !== '' && inputPassword.value !== '') {
			buttonSubmit.removeAttribute('disabled');
		} else {
			buttonSubmit.setAttribute('disabled', true);
		}
	};
	
	inputs.forEach(input => {
		input.oninput = handleInputChange;
	});
});